import {ZonedDateTime, DateTimeFormatter, ZoneId} from '@js-joda/core';
import '@js-joda/timezone';
import axios from "axios";

const FORMATTER = DateTimeFormatter.ofPattern('yyyy-MM-dd HH:mm');

export function validURL(str) {
    const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
}

export function getUrlParameter(name) {
    const url = window.location.search;

    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2]);
}

export function setUrlParam(paramName, paramVal) {
    var url = new URL(window.location.href);
    var urlParams = url.searchParams;

    urlParams.set(paramName, paramVal);
    url.search = urlParams.toString();

    window.history.pushState("object or string", "Title", url.toString());
}

export function isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    } else {
        return false;
    }
}

export function capitalizeText(text) {
    return String(text).charAt(0).toUpperCase() + String(text).toLowerCase().slice(1);
}

export function onlyNumberKey (evt) {
    // Only ASCII character in that range allowed
    const ASCIICode = (evt.which) ? evt.which : evt.keyCode;
    return !(ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57));
}

export function tagsValidations (str) {
    const reg =/<(.|\n)*?>/g;
    return reg.test(str) === true && str.length > 0;
}

export function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

/**
 * Formats input zoned-based date time string to instant date time string depends on PP user settings
 *
 * @param zdtStr
 * @returns {string}
 */
export function formatZonedDateTime (zdtStr) {
    if (zdtStr) {
        const userTimeZoneId = window.parent.mainApp.userTimeZoneId;
        const userTz = ZoneId.of(userTimeZoneId);
        const zdt = ZonedDateTime.parse(zdtStr);
        return userTz.id() === zdt.zone().id() ? zdt.format(FORMATTER) : zdt.withZoneSameInstant(userTz).format(FORMATTER);
    }
    return '';
}

export function scrollToElement (elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ block: "center", behavior: "smooth" });
    }
}

export function openDocument(fileHash, docType) {
    return axios.get('/api/attachment/' + fileHash + '/download', { responseType: 'blob' })
        .then((resp)=> {
            let file = {};

            if (docType === 'PDF') {
                file = new Blob([resp.data], {type: 'application/pdf'});
            } else if (docType === 'DOCX') {
                file = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            } else if (docType === 'EXCEL') {
                file = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
            } else if (docType === 'PRESENTATION') {
                file = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
            } else if (docType === 'HTML_TEXT') {
                file = new Blob([resp.data], { type: 'text/html' });
            }

            window.open(URL.createObjectURL(file));
        })
}